/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import {
  createAPIAction,
  createResetAPIAction,
} from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('gateway', [
  'gateway',
  'addGateway',
  'updateGateway',
  'deleteGateway',
  'gatewayData',
  'gatewayConf',
  'getGateways',
  'getGatewayTOAStats',
  'getGatewayPktStats',
  'getGatewaySFStats',
  'getGatewayFreqStats',
  'getAppGateway',
]);

function gateway(id) {
  return createAPIAction(
    types.gateway,
    {
      endpoint: `/lora/gateways/${id}`,
      method: 'GET',
    })();
}

function resetGetGateway() {
  return createResetAPIAction(types.gateway);
}

function addGateway(data) {
  return createAPIAction(
    types.addGateway,
    {
      endpoint: '/lora/gateways',
      method: 'POST',
      body: data,
    },
  )();
}

function deleteGateway(id) {
  return createAPIAction(
    types.deleteGateway,
    {
      endpoint: `/lora/gateways/${id}`,
      method: 'DELETE',
    },
  )();
}

function updateGateway(id, data) {
  return createAPIAction(
    types.updateGateway,
    {
      endpoint: `/lora/gateways/${id}`,
      method: 'PUT',
      body: data,
    },
  )();
}

function resetDeleteGateway() {
  return createResetAPIAction(types.deleteGateway)();
}

function gatewayData(id, args) {
  return createAPIAction(
    types.gatewayData,
    {
      endpoint: `/lora/gateways/${id}/samples`,
      method: 'GET',
      query: args,
    },
  )();
}

function gatewayConf(id) {
  return createAPIAction(
    types.gatewayConf,
    {
      endpoint: `/lora/gateways/${id}/readconf`,
      method: 'POST',
    },
  )();
}

function getGateways(args) {
  return createAPIAction(
    types.getGateways,
    {
      endpoint: '/lora/gateways',
      query: args,
    },
  )();
}

function getGatewayTOAStats(id, args) {
  return createAPIAction(
    types.getGatewayTOAStats,
    {
      endpoint: `/lora/gateways/${id}/stats/toa`,
      query: args,
    },
  )();
}

function getGatewayPktStats(id, args) {
  return createAPIAction(
    types.getGatewayPktStats,
    {
      endpoint: `/lora/gateways/${id}/stats`,
      query: args,
    },
  )();
}

function getGatewaySFStats(id, args) {
  return createAPIAction(
    types.getGatewaySFStats,
    {
      endpoint: `/lora/gateways/${id}/stats/sf`,
      query: args,
    },
  )();
}

function getGatewayFreqStats(id, args) {
  return createAPIAction(
    types.getGatewayFreqStats,
    {
      endpoint: `/lora/gateways/${id}/stats/freq`,
      query: args,
    },
  )();
}

function getAppGateway(appid) {
  return createAPIAction(
    types.getAppGateway,
    {
      endpoint: `/lora/apps/${appid}/gws`,
    },
  )();
}

export default {
  gateway,
  addGateway,
  updateGateway,
  deleteGateway,
  resetGetGateway,
  resetDeleteGateway,
  gatewayData,
  gatewayConf,
  getGateways,
  getGatewayTOAStats,
  getGatewayPktStats,
  getGatewaySFStats,
  getGatewayFreqStats,
  getAppGateway,
};




// WEBPACK FOOTER //
// ./src/redux/actions/gateway.js